import '../common/dumbStubs'
import '../common/setBaseApp'
import { mountRoot } from 'app/common/mountRoot'
import { Search } from 'modules-ui/search'
import syrinscape from 'app/common/syrinscape'

export const createSearch = () => {
	return {
		init: async (token: string) => {
			await syrinscape.config.init(token)
			mountRoot(Search, 'elastic-search-panel')
		},
	}
}

export const search = createSearch()
export default search

Object.assign(syrinscape, { search })
